var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-box",
    _vm._g(
      {
        attrs: {
          "is-visible": true,
          title: _vm.title,
          "show-action-close": "",
          "navigation-class-list": _vm.navigationClassList,
          "data-qa": `${_vm.currentKey}`,
        },
        on: { "action-close": _vm.onClose },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function () {
              return [
                _c(
                  "div",
                  { class: _vm.actionsWrapperClasses },
                  _vm._l(_vm.actionItems, function (action) {
                    return _c(
                      "base-text",
                      {
                        key: action.key,
                        staticClass: "_tc--accent _ttl _cur-p",
                        attrs: { as: "span" },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.onChange(action.key)
                          },
                        },
                      },
                      [
                        action.showLeft
                          ? _c("base-icon", {
                              staticClass: "_mr-1",
                              attrs: {
                                name: "chevron-left",
                                "icon-namespace": "fa",
                                "data-qa": "previous",
                              },
                            })
                          : _vm._e(),
                        _vm._v(
                          "\n                " +
                            _vm._s(action.text) +
                            "\n                "
                        ),
                        action.showRight
                          ? _c("base-icon", {
                              staticClass: "_ml-1",
                              attrs: {
                                name: "chevron-right",
                                "icon-namespace": "fa",
                                "data-qa": "next",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      },
      _vm.$listeners
    ),
    [
      _c(
        "div",
        [
          _vm._v("\n        " + _vm._s(_vm.text) + "\n        "),
          _c(
            "base-text",
            {
              staticClass: "gfu-link gfu-link--accent",
              attrs: {
                as: "a",
                href: _vm.learnMoreUrl,
                target: "_blank",
                "data-qa": "learn-more",
              },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.Resources.ProjectHome.ProjectSummaryLearnMoreButton
                ) + "."
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }